<template>
  <div>
  <info  v-slot:body image-src="img/photo.jpg">
        <p
        >
          My name is Wengran Wang (王翁然). I am a PhD candidate at the Department of Computer Science,
          <a href="https://www.ncsu.edu/">
            <span>North Carolina State University.</span>
          </a>
          I am researching at
          <a href="https://hintslab.wordpress.ncsu.edu/">
            <span>HINTS Lab</span></a>,
          advised by
          <a href="https://people.engr.ncsu.edu/twprice/website/">
            <span>Dr. Thomas W. Price.</span>
          </a>
        </p>
    </info>
  <v-container
                               style="background-color: #fbfbfb">

    <h5>What I do as a Computing Education researcher:</h5>
    <br>
    <p>
      Despite the growing national interest in recruiting more computer science students, computer science remains a
      subject that contains <a href="https://www.pnas.org/doi/full/10.1073/pnas.2100030118">stereotypes</a>,
      <a href="https://dl.acm.org/doi/abs/10.1145/3501385.3543963">gender bias</a>,
      <a href="https://par.nsf.gov/servlets/purl/10221067">racial discriminations</a>,
      and curriculums that constantly <a href="https://dl.acm.org/doi/abs/10.1145/1083431.1083474">lose students</a>,
      who perceive computer science as being <a href="https://www.sciencedirect.com/science/article/pii/S0360131506001953"> "boring and irrelevant" </a>.

    </p>

    <p>

      My research goal is to help novice students see computing as a tool they could use to pursue their personal ideas and interests,
      and build things that are <i>interesting, meaningful, and creative</i> to them.

    </p>

    <p>In specific, my research focus on the following two areas:</p>
    <p><strong>1. Data-driven, automated feedback for programming practice assignments.</strong> Students can easily get stuck and feel frustrated when working on a programming assignment. I have built multiple tools to help students feel motivated and progress through programming practices:</p>
    <ul>
      <li><a href="https://emmableu.github.io/publications/wang2020crescendo.pdf">Crescendo</a>, a self-paced programming practice environment that combines the block-based and visual, interactive programming of Snap.</li>
      <li><a href="https://emmableu.github.io/publications/wang2020step.pdf">Step Tutor</a>, a tool that helps struggling students during programming by presenting them with relevant, step-by-step examples. </li>
      <li><a href="https://emmableu.github.io/publications/wang2021snapcheck.pdf">SnapCheck</a>, which conducts dynamic testing to Snap programs.</li>
      <li><a href="https://emmableu.github.io/publications/wang2021execution.pdf">Execution-Trace-Based Feature Engineering Approach</a>, which extracts sequential patterns from execution traces to perform code classification and feedback generation tasks. </li>
    </ul>
    <br>
    <p><strong>2. Example support for creative, open-ended programming.</strong> The second part of my work focus on how to use code examples to support open-ended programming. </p>
    <ul>
      <li>My work on <a href="https://emmableu.github.io/publications/wang2021novices.pdf">Novices&#39; Learning Barriers When Using Code Examples in Open-Ended Programming</a> investigated the challenges of example use during open-ended programming.</li>
      <li>My work on <a href="https://emmableu.github.io/publications/wang2022exploring.pdf">Exploring Design Choices to Support Novices&#39; Example Use During Creative Open-Ended Programming</a> presents the design of a remodeled system Example Helper, encouraging students to test and modify examples before integrating them into their own code. </li>
      <li>I built a record-and-replay tool called <a href="https://emmableu.github.io/publications/wang2022pinpoint.pdf">Pinpoint</a>. Using Pinpoint, students can understand and reuse an existing program by isolating the code responsible for specific events during program execution.</li>
    </ul>
    <br>



    <p>

      My research spans across the communities and venues including Computing Education Research (e.g., SIGCSE and ITiCSE),
      Human-Computer Interation (e.g., VL/HCC),
      Software Engineering (e.g., ESE) and Learning Analytics (e.g., LAK and EDM).

    </p>



    <p>
      Before joining HINTS Lab, I did my undergraduate study in Zhejiang University, Hangzhou, China.
    </p>

    <p>
    Please email me (wwang33 AT ncsu.edu) to tell me about your ideas or ask me any questions!
    </p>
  </v-container>
  </div>

</template>
<script>
import info from './info';

    export default {
    name: 'research',
    components:{
    info
    },
    data: () => ({
    }),
  }
</script>
